import { render, staticRenderFns } from "./VIdentifyDocument.vue?vue&type=template&id=4ed68bf2"
import script from "./VIdentifyDocument.vue?vue&type=script&lang=js"
export * from "./VIdentifyDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports